import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    waiterVisibilitySelector,
    actions as waiterOfProcessActions,
    waiterChildrenAreExistSelector,
    videoWaiterBusySelector
} from 'redux/modules/waiter-of-process';

import { ClipServiceInformerWrapper, DownloadClipServiceIcon } from '../app-private-styled-components';

const ClipServiceInformer = () => {
    const waiterVisibility = useSelector(waiterVisibilitySelector);
    const waiterChildrenAreExist = useSelector(waiterChildrenAreExistSelector);
    const videoWaiterIsBusy = useSelector(videoWaiterBusySelector);

    const dispatch = useDispatch();

    const handleClickIcon = useCallback(() => {
        if (waiterVisibility) {
            dispatch(waiterOfProcessActions.deActivateWaiter());
        }
        if (!waiterVisibility) {
            dispatch(waiterOfProcessActions.activateWaiter());
        }
    }, [dispatch, waiterVisibility]);

    if (!waiterChildrenAreExist) {
        return null;
    }

    return (
        <ClipServiceInformerWrapper isAvailable>
            <DownloadClipServiceIcon onClick={handleClickIcon} inProgress={videoWaiterIsBusy} />
        </ClipServiceInformerWrapper>
    );
};

export default ClipServiceInformer;
